



































































import ContactLensSKU from '@/models/item/sku/contact-lens'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import ContactLensItemDetailStore from '../store'

@Component
/**
 * Safari(iOS, Mac共に)ではセレクトボックス内の中央寄せに対応していない。
 * そのため、中央寄せするために、このコンポーネントではセレクトボックスのopacityを0にして、その上に表示用の要素をオーバーレイすることで、中央寄せを可能にしている。
 * 留意事項1: 純粋にCSSで解決できればassetsの方でスタイル定義してより汎用的なものとしたいが、表示用の要素のテキストをJSで書き換えているため、Vue側でスタイル定義も行っている。
 * 留意事項2: Safariの場合に中央寄せしたい、というユースケースが広く見られる場合は、Vueコンポーネントとしてもより汎用化したい。
 */
export default class ContactLensPowerLeftDropdown extends Vue {
  @Prop({ required: true })
  id: string

  @Prop({ required: true })
  store: ContactLensItemDetailStore | null

  @Prop({ required: true })
  isLoading: boolean

  readonly dropdownNotSelected: string = 'not_selected'
  readonly dropdownNotSelectedLabel: string = '選択しない'

  get selectBoxClass(): string[] {
    return [
      'dropdown', 'dropdown--power', 'dropdown--power--left', 'dropdown-power-text',
      ...this.selectedId === this.dropdownNotSelected ? [
        'dropdown-not-selected-text',
      ] : [],
    ]
  }

  /**
   * セレクトボックス本体を隠して、（中央寄せのために）オーバーレイ表示されるDOM要素のテキスト
   */
  get overlayLabel(): string {
    if (this.isLoading) {
      return ''
    }

    const maybeSku = this.skus.find(
      sku => sku.id.short === this.selectedId
    )

    return maybeSku ? this.generateOptionText(maybeSku) : '選択しない'
  }

  get selectedId(): string {
    return this.store && this.store.selectedLeftSku ? this.store.selectedLeftSku.id.short : this.dropdownNotSelected
  }

  get skus(): ContactLensSKU[] {
    return this.store ? this.store.skus : []
  }

  generateOptionText(sku: ContactLensSKU): string {
    /**
     * 新作リクエスト商品については、度数プルダウンのテキストにSOLDOUTをつけない
     * @see https://my-color.esa.io/posts/588
     */
    return sku.cartInfo.newitem && sku.isSoldOut ? sku.power : `${sku.power} ${sku.stockStatusText}`
  }

  onChange($event): void {
    if (this.store) {
      this.store.selectSku('left', this.skus.find(sku => sku.id.short === $event.target.value) || null)
    }
  }
}
